import styled, { css } from 'styled-components'
// components
import MenuItemOrigin from '@mui/material/MenuItem'
// themes
import colors from 'themes/colors'
// utils
import { darken } from 'polished'

export const MenuItem = styled(MenuItemOrigin)`
  display: flex;
  gap: 6px;
  padding-left: 8px;
  align-items: center;
  font-size: 15px;
`

export const ButtonLabel = styled.div<{ disabled?: boolean }>`
  cursor: pointer;
  color: ${colors.blue500};
  display: flex;
  align-items: center;

  span {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  svg {
    margin-right: 4px !important;
  }

  &:hover {
    color: ${darken(0.1, colors.blue500)};

    svg {
      path {
        fill: ${darken(0.1, colors.blue500)};
      }
    }
  }

  ${({ disabled }) =>
    disabled &&
    css`
      cursor: default;
      color: ${colors.gray320};

      svg {
        path {
          fill: ${colors.gray320};
        }
      }

      &:hover {
        color: ${colors.gray320};

        svg {
          path {
            fill: ${colors.gray320};
          }
        }
      }
    `};
`
